import { render, staticRenderFns } from "./AssetList.vue?vue&type=template&id=ee6dedce&scoped=true&"
import script from "./AssetList.vue?vue&type=script&lang=js&"
export * from "./AssetList.vue?vue&type=script&lang=js&"
import style0 from "./AssetList.vue?vue&type=style&index=0&id=ee6dedce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee6dedce",
  null
  
)

/* custom blocks */
import block0 from "./AssetList.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports